export default __webpack_public_path__ + "static/media/icon6.edb05b03.svg";